// extracted by mini-css-extract-plugin
export default {"page":"x2-z","cartModal":"y2-z","checkout":"z2-z","placeholder":"A2-z","account":"B2-z"};